var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    viewBox: "0 0 72 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0103 17.2174H42.9906L45.8545 11.7252C45.9261 11.5999 45.9697 11.4606 45.9823 11.3169C45.9949 11.1732 45.9762 11.0285 45.9276 10.8927C45.8789 10.7569 45.8013 10.6332 45.7003 10.5302C45.5993 10.4273 45.4771 10.3474 45.3422 10.2962L41.3419 8.76933L41.8861 7.67787C41.9622 7.52566 41.9981 7.35655 41.9904 7.18657C41.9828 7.01659 41.9318 6.85139 41.8424 6.70664C41.753 6.56188 41.628 6.44238 41.4794 6.35948C41.3308 6.27657 41.1635 6.233 40.9934 6.23291H31.0075C30.8373 6.23283 30.6698 6.27627 30.5211 6.35911C30.3724 6.44195 30.2473 6.56143 30.1578 6.70621C30.0682 6.85099 30.0172 7.01626 30.0095 7.18632C30.0018 7.35638 30.0377 7.52559 30.1138 7.67787L30.659 8.76933L26.6576 10.2922C26.5223 10.3434 26.3997 10.4235 26.2984 10.5268C26.1971 10.6301 26.1194 10.7542 26.0708 10.8905C26.0221 11.0268 26.0037 11.172 26.0168 11.3161C26.0298 11.4603 26.074 11.5998 26.1464 11.7252L29.0103 17.2174Z",
    fill: "url(#paint0_linear_743_3233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0778 16.2173H27.9238C27.9238 16.2173 15.2314 35.1858 15.2314 46.8588C15.2314 53.3971 17.9292 64.3682 36.0008 64.3682C54.0724 64.3682 56.7702 53.3971 56.7702 46.8588C56.7702 35.1858 44.0778 16.2173 44.0778 16.2173Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0778 16.2173H27.9238C27.9238 16.2173 15.2314 35.1858 15.2314 46.8588C15.2314 53.3971 17.9292 64.3682 36.0008 64.3682C54.0724 64.3682 56.7702 53.3971 56.7702 46.8588C56.7702 35.1858 44.0778 16.2173 44.0778 16.2173Z",
    fill: "url(#paint1_linear_743_3233)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0778 16.2173H27.9238C27.9238 16.2173 15.2314 35.1858 15.2314 46.8588C15.2314 53.3971 17.9292 64.3682 36.0008 64.3682C54.0724 64.3682 56.7702 53.3971 56.7702 46.8588C56.7702 35.1858 44.0778 16.2173 44.0778 16.2173Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0778 16.2173H27.9238C27.9238 16.2173 15.2314 35.1858 15.2314 46.8588C15.2314 53.3971 17.9292 64.3682 36.0008 64.3682C54.0724 64.3682 56.7702 53.3971 56.7702 46.8588C56.7702 35.1858 44.0778 16.2173 44.0778 16.2173Z",
    fill: "url(#paint2_linear_743_3233)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -16.1719,
    y: -3.65186,
    width: 104.348,
    height: 99.6521
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_0_743_3233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3233)",
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9586 20.3481H25.0455C25.0455 20.3481 7.82812 40.696 7.82812 53.2177C7.82812 60.2315 11.4876 72.0003 36.002 72.0003C60.5165 72.0003 64.1759 60.2315 64.1759 53.2177C64.1759 40.696 46.9586 20.3481 46.9586 20.3481Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9586 20.3481H25.0455C25.0455 20.3481 7.82812 40.696 7.82812 53.2177C7.82812 60.2315 11.4876 72.0003 36.002 72.0003C60.5165 72.0003 64.1759 60.2315 64.1759 53.2177C64.1759 40.696 46.9586 20.3481 46.9586 20.3481Z",
    fill: "url(#paint3_linear_743_3233)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6777 20.9478C46.6818 20.9526 46.6862 20.9574 46.6904 20.9624C46.8152 21.1129 46.9985 21.336 47.2324 21.6245C47.7003 22.2017 48.3694 23.0415 49.1729 24.0884C50.7802 26.1829 52.9224 29.1046 55.0635 32.4136C57.2056 35.7242 59.3399 39.4118 60.9365 43.0405C62.5375 46.6791 63.5761 50.2091 63.5762 53.2173C63.5762 56.6251 62.688 61.1383 58.8662 64.8062C55.0399 68.4784 48.1726 71.3999 36.002 71.3999C23.8313 71.3999 16.964 68.4784 13.1377 64.8062C9.31596 61.1383 8.42773 56.6251 8.42773 53.2173C8.42783 50.2091 9.46642 46.6791 11.0674 43.0405C12.664 39.4118 14.7983 35.7242 16.9404 32.4136C19.0815 29.1046 21.2237 26.1829 22.8311 24.0884C23.6345 23.0415 24.3036 22.2017 24.7715 21.6245C25.0054 21.3359 25.1897 21.1129 25.3145 20.9624C25.3185 20.9575 25.3222 20.9525 25.3262 20.9478H46.6777Z",
    stroke: "url(#paint4_linear_743_3233)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_743_3233)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5437,
    cy: 44.6803,
    rx: 17.6306,
    ry: 16.843,
    transform: "rotate(-84.1811 35.5437 44.6803)",
    fill: "url(#paint5_linear_743_3233)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.65332,
    y: -24,
    width: 79.3069,
    height: 65.2173
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_1_743_3233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3233)",
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0452 17.2174H46.9583L51.4473 8.6087C51.5595 8.41237 51.6279 8.19407 51.6476 7.96881C51.6674 7.74355 51.6381 7.51668 51.5618 7.30382C51.4855 7.09096 51.364 6.89716 51.2056 6.73576C51.0472 6.57436 50.8558 6.44919 50.6444 6.36887L44.3741 3.97565L45.2272 2.26487C45.3464 2.0263 45.4027 1.76122 45.3907 1.49479C45.3787 1.22836 45.2988 0.969419 45.1586 0.74253C45.0184 0.515642 44.8226 0.328335 44.5897 0.198382C44.3568 0.0684299 44.0946 0.000142557 43.8279 1.70063e-07H28.1757C27.9088 -0.0001242 27.6464 0.0679684 27.4133 0.197811C27.1802 0.327653 26.9842 0.514934 26.8438 0.741865C26.7034 0.968796 26.6234 1.22784 26.6113 1.4944C26.5993 1.76096 26.6555 2.02618 26.7748 2.26487L27.6294 3.97565L21.3576 6.36261C21.1455 6.44294 20.9533 6.56841 20.7945 6.73033C20.6357 6.89226 20.5139 7.08677 20.4377 7.30041C20.3615 7.51404 20.3326 7.74169 20.3531 7.96759C20.3735 8.19348 20.4428 8.41224 20.5562 8.6087L25.0452 17.2174Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0452 17.2174H46.9583L51.4473 8.6087C51.5595 8.41237 51.6279 8.19407 51.6476 7.96881C51.6674 7.74355 51.6381 7.51668 51.5618 7.30382C51.4855 7.09096 51.364 6.89716 51.2056 6.73576C51.0472 6.57436 50.8558 6.44919 50.6444 6.36887L44.3741 3.97565L45.2272 2.26487C45.3464 2.0263 45.4027 1.76122 45.3907 1.49479C45.3787 1.22836 45.2988 0.969419 45.1586 0.74253C45.0184 0.515642 44.8226 0.328335 44.5897 0.198382C44.3568 0.0684299 44.0946 0.000142557 43.8279 1.70063e-07H28.1757C27.9088 -0.0001242 27.6464 0.0679684 27.4133 0.197811C27.1802 0.327653 26.9842 0.514934 26.8438 0.741865C26.7034 0.968796 26.6234 1.22784 26.6113 1.4944C26.5993 1.76096 26.6555 2.02618 26.7748 2.26487L27.6294 3.97565L21.3576 6.36261C21.1455 6.44294 20.9533 6.56841 20.7945 6.73033C20.6357 6.89226 20.5139 7.08677 20.4377 7.30041C20.3615 7.51404 20.3326 7.74169 20.3531 7.96759C20.3735 8.19348 20.4428 8.41224 20.5562 8.6087L25.0452 17.2174Z",
    fill: "url(#paint6_linear_743_3233)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1758 0.599609H43.8271C43.9915 0.599697 44.1533 0.642596 44.2969 0.722656C44.4405 0.80278 44.562 0.917737 44.6484 1.05762C44.7348 1.19744 44.7836 1.35729 44.791 1.52148C44.7966 1.64479 44.7788 1.76798 44.7383 1.88379L44.6904 1.99707L43.8369 3.70801L43.542 4.2998L44.1602 4.53613L50.4307 6.92969H50.4316C50.5619 6.97922 50.6798 7.0568 50.7773 7.15625C50.8749 7.25566 50.95 7.37479 50.9971 7.50586C51.0441 7.63702 51.0619 7.77722 51.0498 7.91602C51.0376 8.05475 50.9958 8.18961 50.9268 8.31055L50.9209 8.32129L50.915 8.33105L46.5957 16.6172H25.4082L21.0879 8.33105L21.082 8.32031L21.0762 8.30859L21.0283 8.21582C20.9862 8.1202 20.9597 8.01762 20.9502 7.91309C20.9376 7.77392 20.956 7.63356 21.0029 7.50195C21.0499 7.37027 21.1248 7.25021 21.2227 7.15039C21.3206 7.05054 21.4395 6.97336 21.5703 6.92383H21.5713L27.8428 4.53613L28.4629 4.30078L28.166 3.70801L27.3115 1.99707C27.238 1.84988 27.2035 1.68587 27.2109 1.52148C27.2184 1.35713 27.2679 1.19754 27.3545 1.05762C27.441 0.917721 27.5614 0.80173 27.7051 0.72168C27.8488 0.64161 28.0112 0.599533 28.1758 0.599609Z",
    stroke: "url(#paint7_linear_743_3233)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_743_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5421 46.6342C42.1343 45.3231 40.453 44.3411 38.6194 43.7589L37.1967 43.2158V36.4024C39.2011 36.5695 41.1691 37.0365 43.0349 37.7876L44.4029 34.3629C42.1142 33.4242 39.6755 32.9041 37.2029 32.8274V29.7393H34.7064V32.8791C32.7265 32.996 30.8266 33.7012 29.2501 34.9045C28.6083 35.4077 28.0922 36.053 27.7424 36.7896C27.3926 37.5262 27.2185 38.334 27.2341 39.1493C27.186 40.6279 27.6879 42.0718 28.6428 43.2017C29.8877 44.4888 31.4258 45.4555 33.1255 46.0191L34.6908 46.5982V53.5994C33.3888 53.5638 32.0952 53.3784 30.8356 53.0469C29.5407 52.7397 28.2817 52.2975 27.0791 51.7274V55.6749C29.4955 56.6597 32.0865 57.1443 34.6954 57.0993V61.0436H37.1857V56.9866C39.2735 56.8723 41.2745 56.1132 42.9128 54.814C43.5537 54.2618 44.064 53.5743 44.4069 52.801C44.7499 52.0277 44.9169 51.1879 44.896 50.3422C44.9349 48.9786 44.4505 47.6519 43.5421 46.6342ZM34.7064 42.2939C33.8164 41.9941 32.9976 41.5147 32.3007 40.8852C31.8547 40.4025 31.6164 39.7639 31.637 39.1071C31.6306 38.7799 31.6976 38.4554 31.833 38.1574C31.9684 37.8595 32.1689 37.5957 32.4196 37.3853C33.0769 36.8676 33.8689 36.5493 34.7017 36.4681L34.7064 42.2939ZM37.1967 53.4492V47.4794C38.1186 47.7702 38.9784 48.2298 39.7323 48.8349C39.9796 49.0609 40.1753 49.3375 40.3061 49.646C40.4368 49.9545 40.4995 50.2875 40.4899 50.6224C40.492 52.1688 39.3942 53.1111 37.1967 53.4492Z",
    fill: "white",
    fillOpacity: 0.28
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.04297,
    y: -6.78223,
    width: 69.9131,
    height: 51.1304
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_2_743_3233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_743_3233)",
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.956 17.2178H25.043V20.3482H46.956V17.2178Z",
    fill: "url(#paint8_linear_743_3233)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.688477,
    y: -20.0244,
    width: 54.2578,
    height: 56.5569
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_3_743_3233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_743_3233)",
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7709 10.2568L27.6295 3.97559L24.6885 5.09472L27.9754 11.6561C28.0663 11.8416 28.193 12.0073 28.3483 12.1436C28.5035 12.2799 28.6842 12.3841 28.8799 12.4502C29.0756 12.5163 29.2825 12.5431 29.4885 12.5289C29.6946 12.5147 29.8959 12.4598 30.0806 12.3675C30.2654 12.2752 30.4301 12.1472 30.5652 11.9909C30.7003 11.8346 30.8031 11.6531 30.8677 11.4569C30.9323 11.2607 30.9574 11.0536 30.9416 10.8476C30.9258 10.6417 30.8694 10.4409 30.7756 10.2568H30.7709Z",
    fill: "url(#paint9_linear_743_3233)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 17.0566,
    y: -20.0244,
    width: 54.2578,
    height: 56.5569
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_4_743_3233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_743_3233)",
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2319 10.2568L44.3733 3.97559L47.3144 5.09472L44.0274 11.6561C43.9365 11.8416 43.8098 12.0073 43.6545 12.1436C43.4993 12.2799 43.3186 12.3841 43.1229 12.4502C42.9272 12.5163 42.7204 12.5431 42.5143 12.5289C42.3082 12.5147 42.107 12.4598 41.9222 12.3675C41.7374 12.2752 41.5727 12.1472 41.4376 11.9909C41.3026 11.8346 41.1998 11.6531 41.1352 11.4569C41.0706 11.2607 41.0454 11.0536 41.0612 10.8476C41.077 10.6417 41.1334 10.4409 41.2272 10.2568H41.2319Z",
    fill: "url(#paint10_linear_743_3233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3233",
    x: -16.1719,
    y: -3.65186,
    width: 104.348,
    height: 99.6521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_743_3233_clip_path",
    transform: "translate(16.1719 3.65186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9586 20.3481H25.0455C25.0455 20.3481 7.82812 40.696 7.82812 53.2177C7.82812 60.2315 11.4876 72.0003 36.002 72.0003C60.5165 72.0003 64.1759 60.2315 64.1759 53.2177C64.1759 40.696 46.9586 20.3481 46.9586 20.3481Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_743_3233",
    x: 4.69092,
    y: 13.0564,
    width: 61.7053,
    height: 63.2478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_743_3233"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3233",
    x: -3.65332,
    y: -24,
    width: 79.3069,
    height: 65.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3233_clip_path",
    transform: "translate(3.65332 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0452 17.2174H46.9583L51.4473 8.6087C51.5595 8.41237 51.6279 8.19407 51.6476 7.96881C51.6674 7.74355 51.6381 7.51668 51.5618 7.30382C51.4855 7.09096 51.364 6.89716 51.2056 6.73576C51.0472 6.57436 50.8558 6.44919 50.6444 6.36887L44.3741 3.97565L45.2272 2.26487C45.3464 2.0263 45.4027 1.76122 45.3907 1.49479C45.3787 1.22836 45.2988 0.969419 45.1586 0.74253C45.0184 0.515642 44.8226 0.328335 44.5897 0.198382C44.3568 0.0684299 44.0946 0.000142557 43.8279 1.70063e-07H28.1757C27.9088 -0.0001242 27.6464 0.0679684 27.4133 0.197811C27.1802 0.327653 26.9842 0.514934 26.8438 0.741865C26.7034 0.968796 26.6234 1.22784 26.6113 1.4944C26.5993 1.76096 26.6555 2.02618 26.7748 2.26487L27.6294 3.97565L21.3576 6.36261C21.1455 6.44294 20.9533 6.56841 20.7945 6.73033C20.6357 6.89226 20.5139 7.08677 20.4377 7.30041C20.3615 7.51404 20.3326 7.74169 20.3531 7.96759C20.3735 8.19348 20.4428 8.41224 20.5562 8.6087L25.0452 17.2174Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_743_3233",
    x: 27.0791,
    y: 29.7393,
    width: 17.8191,
    height: 39.3044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_743_3233",
    x: 1.04297,
    y: -6.78223,
    width: 69.9131,
    height: 51.1304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3233_clip_path",
    transform: "translate(-1.04297 6.78223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.956 17.2178H25.043V20.3482H46.956V17.2178Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_743_3233",
    x: 0.688477,
    y: -20.0244,
    width: 54.2578,
    height: 56.5569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_743_3233_clip_path",
    transform: "translate(-0.688477 20.0244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7709 10.2568L27.6295 3.97559L24.6885 5.09472L27.9754 11.6561C28.0663 11.8416 28.193 12.0073 28.3483 12.1436C28.5035 12.2799 28.6842 12.3841 28.8799 12.4502C29.0756 12.5163 29.2825 12.5431 29.4885 12.5289C29.6946 12.5147 29.8959 12.4598 30.0806 12.3675C30.2654 12.2752 30.4301 12.1472 30.5652 11.9909C30.7003 11.8346 30.8031 11.6531 30.8677 11.4569C30.9323 11.2607 30.9574 11.0536 30.9416 10.8476C30.9258 10.6417 30.8694 10.4409 30.7756 10.2568H30.7709Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_743_3233",
    x: 17.0566,
    y: -20.0244,
    width: 54.2578,
    height: 56.5569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3233"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_743_3233_clip_path",
    transform: "translate(-17.0566 20.0244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2319 10.2568L44.3733 3.97559L47.3144 5.09472L44.0274 11.6561C43.9365 11.8416 43.8098 12.0073 43.6545 12.1436C43.4993 12.2799 43.3186 12.3841 43.1229 12.4502C42.9272 12.5163 42.7204 12.5431 42.5143 12.5289C42.3082 12.5147 42.107 12.4598 41.9222 12.3675C41.7374 12.2752 41.5727 12.1472 41.4376 11.9909C41.3026 11.8346 41.1998 11.6531 41.1352 11.4569C41.0706 11.2607 41.0454 11.0536 41.0612 10.8476C41.077 10.6417 41.1334 10.4409 41.2272 10.2568H41.2319Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3233",
    x1: 26.8449,
    y1: 8.42981,
    x2: 47.7071,
    y2: 13.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3233",
    x1: 15.2314,
    y1: 16.2173,
    x2: 64.9328,
    y2: 27.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3233",
    x1: 15.2314,
    y1: 16.2173,
    x2: 64.9328,
    y2: 27.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768418,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3233",
    x1: 7.82813,
    y1: 20.3481,
    x2: 73.4486,
    y2: 38.5252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3233",
    x1: 9.58899,
    y1: 22.696,
    x2: 64.176,
    y2: 22.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3233",
    x1: 33.5636,
    y1: 44.7891,
    x2: 44.7773,
    y2: 57.1557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba6be7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3233",
    x1: 20.3467,
    y1: 0,
    x2: 52.7051,
    y2: 14.9401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF31CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3233",
    x1: 21.325,
    y1: 0.782609,
    x2: 51.6536,
    y2: 0.782609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_3233",
    x1: 25.5,
    y1: 18.5,
    x2: 38.7276,
    y2: 29.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_743_3233",
    x1: 24.9492,
    y1: 5.68699,
    x2: 30.6171,
    y2: 6.93777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_743_3233",
    x1: 44.5,
    y1: 4,
    x2: 46.7761,
    y2: 10.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon05);
export default __webpack_public_path__ + "static/media/service-icon05.c071449a50efb85e9dfdb63fad82c594.svg";
export { ForwardRef as ReactComponent };